import { useParams } from 'react-router-dom';
import { Tile } from '@dsi/react-eds';
import ReactEDSWrapper from '../../utils/react-eds-wrapper';
import { useTheme } from '../../hooks/useTheme';
import FeaturePlaybookReport from './Reports_View/Feature_Playbook/FeaturePlaybookReport';
import TroubleReportAssessment from './Reports_View/Trouble_Report/TroubleReportAssessment';

interface PlaceholderReportPageProps {
  title: string;
}

const PlaceholderReportPage: React.FC<PlaceholderReportPageProps> = ({ title }) => {
  const { reportId } = useParams<{ release: string; reportId: string }>();
  const { theme } = useTheme();

  return (
    <div className={theme ? 'light-theme' : 'dark-theme'}>
      <ReactEDSWrapper component={Tile} title={title}>
        {title?.toLowerCase().includes('playbook') ? (
          <FeaturePlaybookReport reportId={reportId || ''} />
        ) : (
          <TroubleReportAssessment reportId={reportId || ''} />
        )}
      </ReactEDSWrapper>
    </div>
  );
};

export default PlaceholderReportPage;
